import { Star } from "lucide-react";

const phrases = [
  "The One-Foot Revolution",
  "Patriotic Ergonomics",
  "Made for American Toilets",
  "Pre-Order Today — Ships Christmas",
  "One Foot Up, Sphincter Down",
  "Release. Relax. Blast.",
];

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {phrases.map((p) => (
      <span key={p} className="flex items-center shrink-0">
        <span className="font-display font-bold uppercase tracking-wide text-lg sm:text-xl text-cream/80 px-6 whitespace-nowrap">
          {p}
        </span>
        <Star className="w-4 h-4 text-crimson fill-crimson shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y border-steel/60 bg-midnight/60 py-4 overflow-hidden"
  >
    <div className="flex w-max animate-marquee">
      <Strip />
      <Strip />
    </div>
  </div>
);
